import { api } from "@/lib/api";

function urlB64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw = atob(base64);
    const output = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; ++i) output[i] = raw.charCodeAt(i);
    return output;
}

export function pushSupported() {
    return (
        typeof window !== "undefined" &&
        "serviceWorker" in navigator &&
        "PushManager" in window &&
        "Notification" in window
    );
}

export function pushPermission() {
    if (!pushSupported()) return "unsupported";
    return Notification.permission; // "default" | "granted" | "denied"
}

export async function ensureServiceWorker() {
    if (!pushSupported()) return null;
    try {
        const reg = await navigator.serviceWorker.register("/sw.js");
        return reg;
    } catch (e) {
        console.warn("SW register failed", e);
        return null;
    }
}

async function subscriptionToBody(sub) {
    const json = sub.toJSON();
    return {
        endpoint: json.endpoint,
        keys: { p256dh: json.keys.p256dh, auth: json.keys.auth },
        user_agent: navigator.userAgent,
    };
}

/** Request permission + subscribe. Returns "granted" | "denied" | "unsupported" | "error". */
export async function enablePush() {
    if (!pushSupported()) return "unsupported";
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return permission; // "denied" or "default"
    const reg = await ensureServiceWorker();
    if (!reg) return "error";
    // Wait for the SW to be active
    if (!reg.active) {
        await new Promise((resolve) => {
            const check = () => {
                if (reg.active) resolve();
                else setTimeout(check, 100);
            };
            check();
        });
    }
    try {
        const { data } = await api.get("/push/vapid-public-key");
        const key = data.public_key;
        if (!key) return "error";
        let sub = await reg.pushManager.getSubscription();
        if (!sub) {
            sub = await reg.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlB64ToUint8Array(key),
            });
        }
        await api.post("/push/subscribe", await subscriptionToBody(sub));
        return "granted";
    } catch (e) {
        console.warn("enablePush failed", e);
        return "error";
    }
}

export async function disablePush() {
    if (!pushSupported()) return;
    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg) return;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
        try {
            await api.post("/push/unsubscribe", await subscriptionToBody(sub));
        } catch (e) {}
        await sub.unsubscribe();
    }
}
